import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/useFleetServicePatchHook";
import useGetHook from "../../customHooks/useFleetServiceGetHook";

const EditRiderComponent = loadable(
  () => import("../../components/Rider/EditRider")
);
const EditRider = () => {
  const { id } = useParams()

  const { data } = useGetHook({
    queryKey: ["Rider"],
    url: `${APIS.DRIVER}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["Rider"],
    navigateURL: "/rider",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Rider</span>
      </div>
      <EditRiderComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        profile={data}
      />
    </>
  );
};
export default EditRider;
